import React from "react";
import { FaWind, FaScrewdriverWrench, FaVials } from "react-icons/fa6";
import { IoShieldCheckmark } from "react-icons/io5";
import { ArrowRight } from "lucide-react";
import "./../../css/HomeMainServices.css";
import featureImage from './../../assets/images/home/feature-item-shape.webp'

const HOME_MAIN_SERVICES = [
  {
    icon: <FaWind color='#0076fe' />,
    title: "Air Pollution Control & Baghouse Services",
    description:
      "Comprehensive solutions for industrial air filtration systems",
  },
  {
    icon: <FaVials color='#0076fe' />,
    title: "Lab Testing Services",
    description:
      "Comprehensive solutions for industrial air filtration systems",
  },
  {
    icon: <IoShieldCheckmark color='#0076fe' />,
    title: "Certified by OSHA & MSHA",
    description: "Fully compliant with safety and health regulations",
  },
  {
    icon: <FaScrewdriverWrench color='#0076fe' />,
    title: "Filter Bag Change-Outs",
    description: "Professional installation and maintenance services",
  },
];

const HomeMainServices = () => {
  return (
    <div className='home-services-grid'>
      {HOME_MAIN_SERVICES.map(({ icon, title, description }) => (
        <div className='service-card' key={title}>
          <img
            src={featureImage}
            alt=''
            className='service-bg-image'
          />
          <div className='service-content'>
            <span className='service-icon'>{icon}</span>
            <span className='service-title'>{title}</span>
            <p className='service-description'>{description}</p>
          </div>
          <a href='/services' className='service-link'>
            <ArrowRight className='arrow-icon' color='#0076fe' />
          </a>
        </div>
      ))}
    </div>
  );
};

export default HomeMainServices;
